import React, { CSSProperties, ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import './style.scss';
import Icon from '../../Utils/NewIcon';
import { useMediaQuery } from '@material-ui/core';

type Props = {
  startExpanded?: boolean;
  children?: React.ReactNode;
  renderIcon?: (onClick: () => void, ref: any) => React.ReactNode;
  dropdown?: boolean;
};

const MobileExpand = ({ startExpanded, children, renderIcon, dropdown }: Props) => {
  const isLargeScreen = useMediaQuery('(min-width: 767px)');
  const isSmallScreen = !isLargeScreen;
  const [expand, setExpand] = useState(startExpanded);
  const display = expand ? 'contents' : 'none';
  const iconRef = useRef(null) as any;

  function getIconBottom() {
    const icon = iconRef?.current;
    if (!icon) {
      return 0;
    }
    const bounds = icon.getBoundingClientRect();
    return (bounds.top + bounds.height) as number;
  }

  const onClick = useCallback(() => {
    setExpand((prev) => !prev);
  }, [setExpand]);

  useEffect(() => {
    setExpand(!isSmallScreen);
  }, [isSmallScreen]);

  if (!children) {
    return null;
  }

  if (!isSmallScreen) {
    return children;
  }

  return (
    <>
      {renderIcon?.(onClick, iconRef) ?? <Icon ref={iconRef} src="ellipsis" onClick={onClick} />}
      <div style={{ display }}>
        {dropdown ?? true ? (
          <MobileStaticDropDown top={getIconBottom()} children={children} />
        ) : (
          children
        )}
      </div>
    </>
  );
};

const MobileStaticDropDown = ({ children, top }: { children?: ReactNode; top: number }) => {
  if (!children) {
    return null;
  }

  const style: CSSProperties = {
    position: 'absolute',
    top,
    left: '10px',
    right: '10px',
    backgroundColor: 'var(--color-bg-surface)',
    zIndex: 10,
    padding: '10px',
    border: '1px solid var(--color-border-default)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  };

  return (
    <div className="mobile-static-dropdown" style={style}>
      {children}
    </div>
  );
};

export default MobileExpand;
